export const isFulfilled = <T>(
	result: PromiseSettledResult<T>
): result is PromiseFulfilledResult<T> => result.status === 'fulfilled';

export const isRejected = <T>(
	result: PromiseSettledResult<T>
): result is PromiseRejectedResult => result.status === 'rejected';
